/*! form-validation */
$(document).ready(function () {
    // Apply maxlength to textarea
    $('.maxlength-140').attr('maxlength', '140');
    $('.maxlength-250').attr('maxlength', '250');
    $('.maxlength-500').attr('maxlength', '500');
    $('.maxlength-1000').attr('maxlength', '1000');
    $('.maxlength-1500').attr('maxlength', '1500');
    $('.maxlength-3000').attr('maxlength', '3000');
});

(function () {
    "use strict";

    var kenticoFormSelector = ".web-request-form";
    var submissionControlSelector = ".FormButton, button[type='submit'], input[type='submit'], input[type='image']";
    var customSubmitHandlerPattern = /(?:PreSubmitKenticoForm|PreSubmitEmployeeInformationKenticoForm)\s*\(/;
    var lockedAttribute = "data-kentico-submission-locked";
    var submittingLabel = "Submitting…";

    function isKenticoForm(form) {
        return form && form.matches(kenticoFormSelector);
    }

    function isFormValid(form) {
        if (typeof form.checkValidity === "function" && !form.checkValidity()) {
            if (typeof form.reportValidity === "function") {
                form.reportValidity();
            }

            return false;
        }

        if (window.jQuery) {
            var jqueryForm = window.jQuery(form);

            if (typeof jqueryForm.valid === "function" && !jqueryForm.valid()) {
                return false;
            }
        }

        return true;
    }

    function saveControlState(control) {
        if (control.kenticoSubmissionState) {
            return;
        }

        control.kenticoSubmissionState = {
            disabled: control.disabled,
            ariaDisabled: control.getAttribute("aria-disabled"),
            value: control.tagName === "INPUT" ? control.value : null,
            content: control.tagName === "BUTTON" ? control.innerHTML : null
        };
    }

    function disableSubmissionControls(form) {
        if (!form.isConnected || form.getAttribute(lockedAttribute) !== "true") {
            return;
        }

        form.querySelectorAll(submissionControlSelector).forEach(function (control) {
            saveControlState(control);
            control.disabled = true;
            control.setAttribute("aria-disabled", "true");

            if (control.classList.contains("FormButton")) {
                if (control.tagName === "INPUT" && control.type !== "image") {
                    control.value = submittingLabel;
                } else if (control.tagName === "BUTTON") {
                    control.textContent = submittingLabel;
                }
            }
        });
    }

    function lockForm(form) {
        if (form.getAttribute(lockedAttribute) === "true") {
            return false;
        }

        form.setAttribute(lockedAttribute, "true");

        // Let Kentico's current handler serialize the successful controls first.
        window.setTimeout(function () {
            disableSubmissionControls(form);
        }, 0);

        return true;
    }

    function restoreControlState(control) {
        var state = control.kenticoSubmissionState;

        if (!state) {
            return;
        }

        control.disabled = state.disabled;

        if (state.ariaDisabled === null) {
            control.removeAttribute("aria-disabled");
        } else {
            control.setAttribute("aria-disabled", state.ariaDisabled);
        }

        if (state.value !== null) {
            control.value = state.value;
        }

        if (state.content !== null) {
            control.innerHTML = state.content;
        }

        delete control.kenticoSubmissionState;
    }

    function unlockForm(form) {
        form.removeAttribute(lockedAttribute);
        form.querySelectorAll(submissionControlSelector).forEach(restoreControlState);
    }

    function stopSubmission(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    document.addEventListener("submit", function (event) {
        var form = event.target;

        if (!isKenticoForm(form)) {
            return;
        }

        if (form.getAttribute(lockedAttribute) === "true" || !isFormValid(form)) {
            stopSubmission(event);
            return;
        }

        lockForm(form);
    }, true);

    document.addEventListener("click", function (event) {
        var control = event.target.closest && event.target.closest(".FormButton");

        if (!control || control.type !== "button") {
            return;
        }

        var inlineHandler = control.getAttribute("onclick") || "";
        var form = control.form;

        if (!customSubmitHandlerPattern.test(inlineHandler) || !isKenticoForm(form)) {
            return;
        }

        if (form.updating || form.getAttribute(lockedAttribute) === "true" || !isFormValid(form)) {
            stopSubmission(event);
            return;
        }

        lockForm(form);
    }, true);

    window.addEventListener("pageshow", function (event) {
        if (!event.persisted) {
            return;
        }

        document.querySelectorAll(kenticoFormSelector + "[" + lockedAttribute + "='true']").forEach(unlockForm);
    });
})();
